var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 1.3335C4.32683 1.3335 1.3335 4.32683 1.3335 8.00016C1.3335 11.6735 4.32683 14.6668 8.00016 14.6668C11.6735 14.6668 14.6668 11.6735 14.6668 8.00016C14.6668 4.32683 11.6735 1.3335 8.00016 1.3335ZM10.2402 9.5335C10.4335 9.72683 10.4335 10.0468 10.2402 10.2402C10.1402 10.3402 10.0135 10.3868 9.88683 10.3868C9.76016 10.3868 9.6335 10.3402 9.5335 10.2402L8.00016 8.70683L6.46683 10.2402C6.36683 10.3402 6.24016 10.3868 6.1135 10.3868C5.98683 10.3868 5.86016 10.3402 5.76016 10.2402C5.56683 10.0468 5.56683 9.72683 5.76016 9.5335L7.2935 8.00016L5.76016 6.46683C5.56683 6.2735 5.56683 5.9535 5.76016 5.76016C5.9535 5.56683 6.2735 5.56683 6.46683 5.76016L8.00016 7.2935L9.5335 5.76016C9.72683 5.56683 10.0468 5.56683 10.2402 5.76016C10.4335 5.9535 10.4335 6.2735 10.2402 6.46683L8.70683 8.00016L10.2402 9.5335Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close-circle.0648654188828201c8161fe699adc9fe.svg";
export { ForwardRef as ReactComponent };